// extracted by mini-css-extract-plugin
module.exports = {"container":"RegistrationForm_container__3c27H","addressBox":"RegistrationForm_addressBox__2lz5Z","button":"RegistrationForm_button__2yYnG"};